import { render, staticRenderFns } from "./item-options.vue?vue&type=template&id=5dd6f4d5&scoped=true"
import script from "./item-options.vue?vue&type=script&lang=js"
export * from "./item-options.vue?vue&type=script&lang=js"
import style0 from "./item-options.vue?vue&type=style&index=0&id=5dd6f4d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6f4d5",
  null
  
)

export default component.exports